import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import moment from "moment";

import { SiteService } from "../../../services/site.service";
import {
  createTicketSellRow,
  getProductPriceInTicketReport,
} from "../../../_utils/utils";
import { ProductService } from "../../../services/product.service";
import { PaymentMethodService } from "../../../services/paymentMethod.service";

export const ticketPaymentComplete = async (paymentObject) => {
  const idProductArray = paymentObject.productId;
  let productArray = [];
  let paymentMethod = "";
  const [currentDate, currentTime] = moment().format().split("T");
  const parsedDate = moment(currentDate, "YYYY-MM-DD").format("DD-MM-YYYY");
  console.log("parsedDate=====", parsedDate);
  let siteObject = {};

  try {
    const result = await SiteService.getSiteById(paymentObject.siteId);
    const body = { idProductArray: [idProductArray] };
    const { data } = await ProductService.getAllProductsInRange(body);
    const res = await PaymentMethodService.getPaymentById(
      paymentObject.paymentMethodId
    );
    paymentMethod = res.data.name;
    siteObject = result.data[0];
    productArray = data;
  } catch (error) {
    console.log("error", error);
    const ticketError = { msg: "Error al generar el ticket de venta" };
    throw ticketError;
  }
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: [197, 80],
  });
  doc.setFontSize(8);
  /** ==== HEADER ===== */
  doc.text("SIERRA MOVIL", 5, 6);
  doc.text("SANDRA GRACIELA MONTES SAMANO", 5, 9);
  doc.text("INDEPENDENCIA No.15", 5, 12);
  doc.text("JALPAN DE SERRA, QUERETARO", 5, 15);
  doc.text("RFC: MOSS690123TD9", 5, 18);
  doc.text("TEL: 4412960318", 5, 21);
  doc.text("ACTIVIDAD EMPRESARIAL Y PROFESIONAL", 5, 24);
  if (siteObject.direction.length >= 20) {
    doc.text(`EXPEDIDO EN ${siteObject.direction.slice(0, 23)}`, 5, 27);
    doc.text(`${siteObject.direction.slice(20)}`, 5, 30);
    doc.text(`SUCURSAL ${siteObject.name}`, 5, 33);
    doc.text(`FECHA ${currentDate}`, 5, 36);
    doc.text(`HORA ${currentTime.split("-")[0]}`, 33, 36);
  } else {
    doc.text(`EXPEDIDO EN ${siteObject.direction.slice(0, 20)}`, 5, 27);
    doc.text(`SUCURSAL ${siteObject.name}`, 5, 30);
    doc.text(`FECHA ${currentDate}`, 5, 33);
    doc.text(`HORA ${currentTime.split("-")[0]}`, 33, 33);
  }

  /**  ==== TABLE HEAD =====*/
  doc.text(
    `TOTALES --- $ ${productArray[0].balance_transfer?.amount || 0}`,
    38,
    42
  );
  doc.text("CANT.", 12, 46);
  doc.text("CANT.", 10, 49);
  doc.text("DESCRIP", 23, 49);
  doc.text("P. UNIT.", 40, 49);
  doc.text("TOTAL", 53, 49);
  doc.text(`METODO DE PAGO ${paymentMethod}`, 6, 73);

  autoTable(doc, {
    margin: { top: 58 },
    body: generateRows(productArray),
    theme: "plain",
    styles: {
      fontSize: 9,
      cellWidth: "wrap",

      font: "times",
    },
  });

  const pageCount = doc.internal.getNumberOfPages();
  /** for loop for set footer in every page */
  for (let i = 0; i < pageCount; i++) {
    doc.setPage(i);
    /** ==== FOOTER ===== */
    doc.text("ESTA NOTA DE VENTA SERA INCLUIDA EN LA FACTURA", 2, 175);
    doc.text("DE CIERRE DE DIA.", 2, 178);
    doc.text("GRACIAS POR SU COMPRA", 2, 181);
    doc.text(
      2,
      184,
      doc.internal.getCurrentPageInfo().pageNumber + "/" + pageCount
    );
  }
  doc.save(`ticket-${parsedDate}.pdf`);
};

const getBalanceDescription = (item) => {
  if (item.balance_transfer) {
    return `Saldo ${item.balance_transfer?.balance_catalogue?.name || ""}`;
  }
};

const generateRows = (productArray) => {
  const buildRow = [];
  productArray.forEach((item) => {
    buildRow.push(
      createTicketSellRow(
        "1",
        getBalanceDescription(item),
        getProductPriceInTicketReport(item),
        getProductPriceInTicketReport(item)
      )
    );
  });
  return buildRow;
};
